module.exports = __webpack_public_path__ + "img/Vectors.a4b5d120.svg";